/* eslint-disable @typescript-eslint/camelcase */
import { DataLayerEvent, EventTracker } from 'Project/ts/library/eventTacker';

import { mapPlanToItemData } from './mapPlanToItemData';
import { PlanElementData } from './types';

export function sendViewItemListEvent(plansData: PlanElementData[]): void {
    const eventData: DataLayerEvent = {
        event: 'view_item_list',
        ecommerce: {
            process_name: 'standard_checkout',
            currency: plansData[0]?.currency || '',
            items: plansData.map(mapPlanToItemData),
        },
    };

    EventTracker.send('ga4dl', { ecommerce: null });
    EventTracker.send('ga4dl', eventData);
}
